import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as AppState from "../state";
import { featureKey, State } from "./claim.reducer";

const selectFeatureState = createFeatureSelector<AppState.State, State>(
  featureKey
);

export const selectClaims = createSelector(
  selectFeatureState,
  (state) => state.claims
);
